import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./Home/Home";
import Product from "./components/Product/Product";
import ProductSoftware from "./components/Product/ProductSoftware";
import Solution from "./components/Solution/Solution";
import About from "./components/About/About";
import VisionMission from "./components/About/VisionMission";
import OurPartners from "./components/About/OurPartners";
import OurCustomers from "./components/About/OurCustomers";
import Career from "./components/About/Career";
import ContactUs from "./components/About/ContactUs";
import UniqueProducts from "./components/Product/UniqueProducts";
import Support from "./Support/Support";
import Allproduct from "./components/Product/Allproduct";
import BackupandDisaster from "./components/Solution/BackupandDisaster";
import EnterpriseSearch from "./components/Solution/EnterpriseSearch";
import Hyperconverge from "./components/Solution/Hyperconverge";
import NetworkandWifi from "./components/Solution/NetworkandWifi";
import Loganalytic from "./components/Solution/Loganalytic";
import Virtualization from "./components/Solution/Virtualization";
import Virtualizationhpvvme from "./components/Solution/Virtualizationhpvvme";
import OpensourceERP from "./components/Solution/OpensourceERP";
import Security from "./components/Solution/Security";
import Firewall from "./components/Solution/Firewall";
import Privilege from "./components/Solution/Privilege";
import VAScan from "./components/Solution/VAScan";
import AutomatePentest from "./components/Solution/AutomatePentest";
import MicrosoftPowerPlatform from "./components/Solution/MicrosoftPowerPlatform";
import GitlabDevOps from "./components/Solution/GitlabDevOps";
import KatalonTestAutomation from "./components/Solution/KatalonTestAutomation";
import CaseStudy from "./components/About/CaseStudy";
import CustomerTicket from "./Support/CustomerTicket";
import CustomerTicket2 from "./Support/CustomerTickets";
import AdminTicket from "./Support/AdminTicket";
import SurveyPage from "./Support/SurveyPage";
import IT from "./components/IT Store/IT";
import { LanguageProvider } from "./components/LanguageContext";
import Maintenance from "./Support/Maintenance";
import Whoweare from "./components/About/Whoweare";
import Intusty from "./components/About/Intusty";
import PasswordReset from "./Support/PasswordReset";
import Pillarcard from "./components/pillarcard/pillarcard";
import TicketDetail from "./Support/TicketDetail";
import TicketDetailAdmin from "./Support/TicketDetailAdmin";
import NewTicketMenu from "./Support/NewTicketLayout";
import SettingMenu from "./Support/SettingLayout";
import CustomerLogs from "./Support/CustomerLogs";
import Infocustomer from "./Support/Infocustomer";
import Ticket2 from "./Support/Ticket2";
import Agent from "./Support/Agent";
import Department from "./Support/Department";
import CreateTickets from "./Support/CreateTickets";
import TicketAssessments from "./Support/TicketAssessments";
import AgentLogs from "./Support/AgentLogs";
import DashboardCus from "./Support/DashboardCus";
import AssetListCustomer from "./Support/AssetListCustomer";
import AssetDetailCustomer from "./Support/AssetDetailCustomer";
import AdminProjectCustomersPage from "./Support/AdminProjectCustomersPage";
import AdminProjectCustomerDetailPage from "./Support/AdminProjectCustomerDetailPage";
// import UploaStandardMAEnquiry from './components/Support/UploaStandardMAEnquiry';
import CustomerAssets from "./Support/CustomerAssets";
import CustomerAssetDetail from "./Support/CustomerAssetDetail";
import CustomerProtectedRoute from "./components/CustomerProtectedRoute";
import AdminUploadStandardMAEnquiry from "./Support/AdminUploadStandardMAEnquiry";
import VeeamIframePage from "./components/Product/VeeamIframePage";
import VeeamPage from "./components/Product/VeeamPage";
import DolibarrCustomerMapping from "../src/Support/DolibarrCustomerMapping";
const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Home />} />
            <Route path="/producthardware" element={<Product />} />
            <Route path="/productsoftware" element={<ProductSoftware />} />
            <Route path="/solutions" element={<Solution />} />
            <Route path="/aboutus" element={<About />} />
            <Route path="/visionmission" element={<VisionMission />} />
            <Route path="/partners" element={<OurPartners />} />
            <Route path="/customer" element={<OurCustomers />} />
            <Route path="/career" element={<Career />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/productunique" element={<UniqueProducts />} />
            <Route path="/support" element={<Support />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/allproduct" element={<Allproduct />} />
            <Route path="/backupanddisaster" element={<BackupandDisaster />} />
            <Route path="/enterprisesearch" element={<EnterpriseSearch />} />
            <Route path="/hyperconverge" element={<Hyperconverge />} />
            <Route path="/networkandwifi" element={<NetworkandWifi />} />
            <Route path="/loganalytic" element={<Loganalytic />} />
            <Route path="/virtualization" element={<Virtualization />} />
            <Route
              path="/hpe-morpheus-vm-essentials-software"
              element={<Virtualizationhpvvme />}
            />
            <Route path="/opensourceerp" element={<OpensourceERP />} />
            <Route path="/security" element={<Security />} />
            <Route path="/firewall" element={<Firewall />} />
            <Route path="/privilegeaccessmanagement" element={<Privilege />} />
            <Route path="/vascreen" element={<VAScan />} />
            <Route path="/automatepentest" element={<AutomatePentest />} />
            <Route path="/whoweare" element={<Whoweare />} />
            <Route
              path="/microsoftpowerplatform"
              element={<MicrosoftPowerPlatform />}
            />
            <Route path="/gitlabdevops" element={<GitlabDevOps />} />
            <Route
              path="/katalontestautomation"
              element={<KatalonTestAutomation />}
            />
            <Route path="/casestudy" element={<CaseStudy />} />
            <Route
              path="/productsoftware/:type"
              element={<VeeamIframePage />}
            />

            <Route path="/survey/:TicketNumber" element={<SurveyPage />} />
            <Route path="/it" element={<IT />} />
            <Route path="/intusty" element={<Intusty />} />
            <Route path="/resetpassword" element={<PasswordReset />} />
            <Route path="/pillarcard" element={<Pillarcard />} />
            <Route path="/product/:type" element={<VeeamPage />} />
            <Route
              path="/customer/tickets"
              element={
                <CustomerProtectedRoute>
                  <CustomerTicket />
                </CustomerProtectedRoute>
              }
            />
            <Route
              path="/customer/ticket/:id"
              element={
                <CustomerProtectedRoute>
                  <TicketDetail />
                </CustomerProtectedRoute>
              }
            />
            <Route
              path="/customer/assets"
              element={
                <CustomerProtectedRoute>
                  <AssetListCustomer />
                </CustomerProtectedRoute>
              }
            />
            <Route
              path="/customer/assets/:id"
              element={
                <CustomerProtectedRoute>
                  <AssetDetailCustomer />
                </CustomerProtectedRoute>
              }
            />
            <Route
              path="/customer/assets/:id/new-ticket"
              element={
                <CustomerProtectedRoute>
                  <NewTicketMenu />
                </CustomerProtectedRoute>
              }
            />

            <Route
              path="/customer/setting"
              element={
                <CustomerProtectedRoute>
                  <SettingMenu />
                </CustomerProtectedRoute>
              }
            />
            <Route
              path="/customer/setting/edit"
              element={
                <CustomerProtectedRoute>
                  <SettingMenu />
                </CustomerProtectedRoute>
              }
            />
            {/* <Route
                    path="/customer/upload-ma-enquiry"
                    element={
                      <CustomerProtectedRoute>
                        <UploaStandardMAEnquiry />
                      </CustomerProtectedRoute>
                    }
                  />   */}
            <Route
              path="/customer/assets-list"
              element={
                <CustomerProtectedRoute>
                  <CustomerAssets />
                </CustomerProtectedRoute>
              }
            />
            <Route
              path="/customer/assets-list/:id"
              element={
                <CustomerProtectedRoute>
                  <CustomerAssetDetail />
                </CustomerProtectedRoute>
              }
            />

            <Route path="/admin" element={<AdminTicket />}>
              <Route path="customer-activity-logs" element={<CustomerLogs />} />
              <Route path="customers" element={<Infocustomer />} />
              <Route path="tickets" element={<Ticket2 />} />
              <Route
                path="dashboard/customer-tickets/:id"
                element={<CustomerTicket2 />}
              />
              <Route path="agent" element={<Agent />} />
              <Route path="department" element={<Department />} />
              <Route path="new" element={<CreateTickets />} />
              <Route
                path="ticket-assessments"
                element={<TicketAssessments />}
              />
              <Route path="agent-logs" element={<AgentLogs />} />
              <Route path="dashboard" element={<DashboardCus />} />
              <Route path="ticketadmin/:id" element={<TicketDetailAdmin />} />
              <Route
                path="customer-assets"
                element={<AdminProjectCustomersPage />}
              />
              <Route
                path="customer-assets/:id"
                element={<AdminProjectCustomerDetailPage />}
              />
              <Route
                path="upload-ma-enquiry"
                element={<AdminUploadStandardMAEnquiry />}
              />
              <Route
                path="dolibarr-mapping"
                element={<DolibarrCustomerMapping />}
              />
            </Route>
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
};

export default App;
